import { Activity, ActivityModel, ActivityStatus } from './activities';

export class WorkflowCategoryVM {
  id: string;
  name: string;
  hasInProgressActivities: boolean;
  staticCategoryType?: string;
}

export class WorkflowCategory {
  id: string;
  name: string;
  clientId?: string;
  workflowId?: string;
  isEditing?: boolean;
  ordinal: number;
  isStatic?: boolean;
  staticCategoryType?: string;
  originalName?: string;

  constructor(options?: Partial<WorkflowCategory>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export class ActivityVM {
  activityDataId?: string;
  activityId?: string;
  activityName: string;
  activity?: Activity<ActivityModel>;
  status?: ActivityStatus;
}
